import { createApp } from "vue";
import { createPinia } from 'pinia'
import axios from 'axios';
import App from "./App.vue";
import store from "./store";
import router from "./router";

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import { authService } from "./services/authService.js";

//------------------------------------------------------------------------------------------------------
axios.interceptors.request.use(
    config => {
        store.state.activeRequests++;
        const token = authService.getAuthToken()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

axios.interceptors.response.use(
    response => {
        store.state.activeRequests--;
        return response;
    },
    async error => {
        store.state.activeRequests--;
        const originalRequest = error.config;

        // nie próbujemy refreshować refresha !!!
        if (originalRequest?.url?.includes('/auth/refresh')) {
            return Promise.reject(error);
        }

        if (
            error.response?.status === 401 && !originalRequest._retry
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return axios(originalRequest);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {

                const newAccessToken = await authService.refresh();

                processQueue(null, newAccessToken);

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                return axios(originalRequest);
            }
            catch (refreshError) {
                processQueue(refreshError, null);

                authService.logout()

                // Pobieramy aktualną ścieżkę, na której znajdował się użytkownik
                const currentRoute = router.currentRoute.value.fullPath;

                // Przekierowujemy z parametrem returnUrl (lub redirect)
                router.replace({
                    path: '/signin',
                    query: { nextUrl: currentRoute }
                });

                return Promise.reject(refreshError);
            }
            finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);
//------------------------------------------------------------------------------------------------------

const pinia = createPinia()
const appInstance = createApp(App);
// appInstance.config.errorHandler = (err) => {

//     console.error('Vue Error:', err);

//     alert(err.message);

//     // lub store.dispatch(...)
// };
appInstance.use(store);
appInstance.use(pinia)
//------------------------------------------------------------------------------------------------------
import { shopService } from "@/services/shopService";
async function loadShops() {
    try {

        const response = await shopService.getShops();

        if (response.data?.Success) {
            console.log(">>>>>>>>>>>>Response Data:", response.data.Data)
            store.commit("SET_SHOPS", response.data.Data);
            store.commit("SET_SELECTED_SHOP", response.data.Data.find(shop => shop.IsSelected) || null);
        }
    } catch (error) {
        console.error(error);
    }
}

await loadShops();

//------------------------------------------------------------------------------------------------------
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
